import { XStack, YStack, Text, styled, Circle } from "tamagui";
import { LinearGradient } from "tamagui/linear-gradient";
import { RiAddLine } from "react-icons/ri";
import { colors } from "@styles/colors";
import { useNavigate } from "react-router-dom";

export const TopUpActionCard = () => {
  const navigation = useNavigate();
  return (
    <YStack zi={2} style={{ position: "relative", width: "100%", top: "50px" }}>
      <LinearGradient
        colors={["#1E40AF", "#2563EB", "#D4AF37"]} // 藍色到金色的質感
        start={[0, 0]}
        end={[1, 0]}
        br="$4"
        py="$3"
        px="$4"
        pressStyle={{ scale: 0.98 }}
        animation="quick"
        shac="rgba(37,99,235,0.3)"
        shar={24}
        shof={{ width: 0, height: 6 }}
        pos="relative"
        ov="hidden"
        onPress={() => navigation("/account/wallet/topUp")}>
        <XStack jc="space-between" ai="center" zi={1}>
          <YStack>
            <Text color="white" fow="800" fontSize={18}>
              立即儲值
            </Text>
            <Text color="rgba(255,255,255,0.8)" fontSize={12} mt="$1">
              儲 $1000 送 $50 · 限時優惠中
            </Text>
          </YStack>

          <LinearGradient
            colors={["#FDE68A", "#F59E0B"]}
            w={48}
            h={48}
            br="$3"
            ai="center"
            jc="center"
            shac="rgba(245,158,11,0.45)"
            shar={8}
            shof={{ width: 0, height: 2 }}>
            <RiAddLine size={24} color={colors.amberDark} style={{ zIndex: 2 }} />
          </LinearGradient>
        </XStack>
      </LinearGradient>
    </YStack>
  );
};
